/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win4_TInputs */

const en_wc_vs_win4_t = /** @type {(inputs: Wc_Vs_Win4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private and offline`)
};

/**
* | output |
* | --- |
* | "Private and offline" |
*
* @param {Wc_Vs_Win4_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win4_t = /** @type {((inputs?: Wc_Vs_Win4_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win4_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win4_t(inputs)
});
export { wc_vs_win4_t as "wc.vs.win4.t" }